import BottomNav from "./BottomNavbar/BottomNav";
import CenterNav from "./CenterNavbar/CenterNav";
import LogInstateNav from "./LoginState/LogInstateNav";
import MobileNav from "./MobileNav/MobileNav";
import TopNavbar from "./TopNavbar/TopNavbar";

import "./Navbar.css";
import NavPopUp from "./NavPopUp";
// import Nav from "../Navbar/Navbar";

const Navbar = () => {
  return (
    <div className="w-full z-50 ">
      {/* <Nav /> */}
      <TopNavbar />
      <CenterNav />
      <MobileNav />
      <BottomNav />
      <LogInstateNav />

      {/* this is the signUp and login pop up that shows on the screen, 
      when registration button is clicked  */}
      <NavPopUp />
    </div>
  );
};

export default Navbar;
